// extracted by mini-css-extract-plugin
export default {"ImageAndQuantity":"ImageAndQuantity-styles__ImageAndQuantity__iJvB7","ImageAndQuantity__ProductImage":"ImageAndQuantity-styles__ImageAndQuantity__ProductImage__ZJZ7G"};